import { render, staticRenderFns } from "./SaleInfoTable.vue?vue&type=template&id=05ac0314&scoped=true"
import script from "./SaleInfoTable.vue?vue&type=script&lang=ts"
export * from "./SaleInfoTable.vue?vue&type=script&lang=ts"
import style0 from "./SaleInfoTable.vue?vue&type=style&index=0&id=05ac0314&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac0314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ac0314')) {
      api.createRecord('05ac0314', component.options)
    } else {
      api.reload('05ac0314', component.options)
    }
    module.hot.accept("./SaleInfoTable.vue?vue&type=template&id=05ac0314&scoped=true", function () {
      api.rerender('05ac0314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleInfoTable.vue"
export default component.exports